import { getIndicatorStyle } from './styles';

interface PillTabIndicatorProps {
  left: number;
  width: number;
  height: number;
}

export const PillTabIndicator = ({
  left,
  width,
  height
}: PillTabIndicatorProps) => (
  <div style={getIndicatorStyle(left, width, height)} />
);
